import { render, staticRenderFns } from "./OrderDetailReceivedItems.vue?vue&type=template&id=66e34c76&scoped=true&"
import script from "./OrderDetailReceivedItems.vue?vue&type=script&lang=js&"
export * from "./OrderDetailReceivedItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailReceivedItems.vue?vue&type=style&index=0&id=66e34c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e34c76",
  null
  
)

export default component.exports